import { render } from "./logoBackground.vue?vue&type=template&id=dbd63dcc"
import script from "./logoBackground.vue?vue&type=script&lang=js"
export * from "./logoBackground.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/frontend/mobileproject/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__